// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { BrowserRouter } from 'react-router-dom';

// MSAL (Microsoft OAuth)
// Only initialize Microsoft auth when it is configured and the browser exposes
// Web Crypto. Local LAN HTTP test URLs such as http://192.168.x.x are not a
// secure context in Safari/Chrome, so eager MSAL construction crashes before
// the app can load even though EQUDX uses backend JWT login for normal access.
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './lib/authConfig';

const canUseMsal = Boolean(
  msalConfig.auth.clientId &&
    msalConfig.auth.authority &&
    window.isSecureContext &&
    window.crypto?.subtle
);

const AppShell = canUseMsal
  ? ({ children }) => {
      const msalInstance = new PublicClientApplication(msalConfig);
      return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
    }
  : React.Fragment;

// React 18 root render
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppShell>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppShell>
  </React.StrictMode>
);
